import { isEmpty } from 'lodash';
import { isCnpj } from 'utils/cpfcnpj-format';
import { validarCNPJ } from 'utils/cpfcnpj-validate';

export function CnpjValido(cnpj: string): boolean {
  if (!cnpj || !isCnpj(cnpj)) {
    return false;
  }
  return validarCNPJ(cnpj);
}

export function CnpjDominioValido(cnpj: string): boolean {
  if (isEmpty(cnpj)) {
    return false;
  }

  if (isCnpj(cnpj)) {
    return CnpjValido(cnpj);
  }

  return true;
}
